import React from "react";
import { StyleSheet, View } from "react-native";
import { colors, layout } from "@/constants";
import Card from "./base/Card";
import Icon from "./base/Icon";
import Text from "./base/Text";

/**
 * User instructions component that displays helpful tips for using the chat
 * Shows headphones recommendation and feedback instructions with icons
 */
export default function UserInstructions() {
  return (
    <Card style={styles.card}>
      <View style={styles.instructionRow}>
        <Icon
          name="headset"
          size="medium"
          color="primary"
          style={[styles.icon, { color: colors.primary }]}
        />
        <Text
          variant="regular"
          size="small"
          color="primary"
          style={styles.instructionText}
        >
          For the best results, use headphones or find a quiet space.
        </Text>
      </View>

      <View style={styles.instructionRow}>
        <Icon
          name="thumbs_up_down"
          size="medium"
          color="primary"
          style={[styles.icon, { color: colors.primary }]}
        />
        <Text
          variant="regular"
          size="small"
          color="primary"
          style={styles.instructionText}
        >
          Share feedback anytime using the feedback icon.
        </Text>
      </View>
    </Card>
  );
}

const styles = StyleSheet.create({
  card: {
    backgroundColor: colors.surfaceContainer,
    marginHorizontal: layout.space.lg,
    marginTop: layout.space.lg
  },
  instructionRow: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: layout.space.sm
  },
  icon: {
    marginRight: layout.space.sm
  },
  instructionText: {
    flex: 1
  }
});
